import { render, staticRenderFns } from "./Promptpay.vue?vue&type=template&id=6f9bfb59"
import script from "./Promptpay.vue?vue&type=script&lang=js"
export * from "./Promptpay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports